import isOnScreen, { isOnScreenStrict } from "@/utils/isOnScreen"
import { cutUserAvatar } from "@/utils/pic-util.js"
function LazyLoad(){
    cutUserAvatar() // hack:常规文章页左侧头像在懒加载前，对头像进行裁剪 TODO: 其他渠道待优化
    this._replaceImg()
    this.init()
}
LazyLoad.prototype={
    constructor:LazyLoad,
    init:function(){
        window.addEventListener('scroll',_.throttle(this._replaceImg.bind(this),100))
    },
    scanImg: function () {
        this._replaceImg()
    },
    _replaceImg:function(){
        try {
            document.querySelectorAll('img[data-src]').forEach(img => {
                const isStrict = img.getAttribute('data-strict') === 'true';
                const isShow = isStrict ? isOnScreenStrict(img) : isOnScreen(img);
                if (isShow) {
                    const realSrc = img.getAttribute('data-src');
                    img.setAttribute('src', realSrc);
                    img.removeAttribute('data-src');
                }
            });
        } catch (error) {
            console.log('懒加载替换图片源地址失败', error)
        }
    }
}
export default LazyLoad;